import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import { Row, Col, Breadcrumb, Card, Container } from "react-bootstrap";

class About extends Component {
    render() {
        return (
            <div className="mt-4">
                <Breadcrumb className="p-2 rounded">
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>Sobre a Replay Pro</Breadcrumb.Item>
                </Breadcrumb>

                <Container>
                    <div className="text-center my-5">
                        <h2 className="font-weight-bold">Sobre a Replay Pro</h2>
                        <p className="lead text-muted">
                            Elevando a experiência esportiva por meio da tecnologia.
                        </p>
                    </div>

                    <Row className="mb-5 align-items-center">
                        <Col md={6}>
                            <h4 className="font-weight-bold mb-3 text-danger">Quem Somos</h4>
                            <p className="text-dark">
                                A Replay Pro é uma empresa brasileira de base tecnológica focada em soluções inovadoras para o esporte. Desenvolvemos sistemas de replay esportivo instantâneo que combinam <strong>hardware próprio (HaaS)</strong> e <strong>software em nuvem (SaaS)</strong>.
                            </p>
                            <p className="text-dark">
                                Unimos engenharia, software e experiência de usuário para criar produtos escaláveis e confiáveis. Somos uma <strong>startup incubada</strong> e validada por instituições de inovação e tecnologia.
                            </p>
                            <p className="text-dark italic">
                                Nossa equipe é liderada por profissionais com vasta experiência em tecnologia, produto e negócios, comprometidos com a criação de soluções sólidas e escaláveis.
                            </p>
                        </Col>
                        <Col md={6}>
                            <div className="p-4 bg-light rounded shadow-sm border-start border-danger border-5">
                                <h5 className="font-weight-bold">Nossa Missão</h5>
                                <p className="small mb-4">Elevar a experiência esportiva por meio da tecnologia, democratizando o acesso ao replay profissional.</p>

                                <h5 className="font-weight-bold">Nossa Visão</h5>
                                <p className="small mb-0">Ser referência em soluções de replay esportivo e mídia digital na América Latina.</p>
                            </div>
                        </Col>
                    </Row>

                    <div className="mb-5">
                        <h4 className="font-weight-bold mb-5 text-center">Nossos Valores</h4>
                        <Row>
                            {[
                                { title: "Inovação", icon: "bi-lightbulb-fill", text: "Inovação com propósito" },
                                { title: "Confiança", icon: "bi-shield-fill-check", text: "Confiabilidade técnica" },
                                { title: "Simplicidade", icon: "bi-hand-index-thumb-fill", text: "Simplicidade para o usuário" },
                                { title: "Paixão", icon: "bi-heart-fill", text: "Paixão pelo esporte" }
                            ].map((item, index) => (
                                <Col key={index} md={3} className="mb-3">
                                    <Card className="h-100 border-0 shadow-sm text-center py-4">
                                        <Card.Body>
                                            <i
                                                className={`bi ${item.icon} text-danger d-block mb-3`}
                                                style={{ fontSize: '2rem' }}
                                            ></i>
                                            <h5 className="font-weight-bold mb-2">{item.title}</h5>
                                            <p className="small text-muted mb-0">{item.text}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>
            </div>
        );
    }
}

export default withRouter(About);